export default {
  "content": "<path d=\"M9 8h4V5h3l-5-5-5 5h3v3zM8 9H5V6l-5 5 5 5v-3h3V9zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3H9v3H6l5 5 5-5h-3v-3z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "fill": "none",
    "viewBox": "0 0 22 22"
  }
};